import api from "../../index";

export const GetOrganizerListApi = (data) => api.post('task-wise-org', data);
export const AddOrganizerTagApi = (data) => api.post('add-task-tag', data);
export const AssignTaskApi = (data) => api.post('assign-task', data);
export const DeleteOrganizerApi = (data) => api.post('delete-organizer-cascade', data);